import catalogModule from '../catalogModule';

function genreFilters(catalogConstants) {
    "ngInject";
    return {
        restrict: 'A',
        replace: false,
        templateUrl: catalogConstants.templateUrls.genreFiltersTemplate
    }
}

catalogModule.directive("genreFilters", genreFilters);

export default genreFilters;